import { I18n } from '@affine/i18n';

// YOD-739: every yoDEV app routes support to the one form on worX. It is a
// public page (YOD-634), so signed-out users can reach it too; `app=workplace`
// preselects this product. worX serves en/es/pt only, and its default is es.
const WORX_URL = 'https://worx.yodev.dev';

export function yodevSupportUrl(language: string = I18n.language): string {
  const base = (language || '').split('-')[0];
  const locale = base === 'en' || base === 'pt' ? base : 'es';
  return `${WORX_URL}/${locale}/support?app=workplace`;
}
